import {Injectable} from '@angular/core';
import {PersonenTypEnum, PersonenTypEnumLabels, StammdatenEmpfangsbevollmaechtigter} from '@nachdigal';
import {MappedStammdatenEmpfangsbevollmaechtigter} from '@utils-lib';
import {InlandsadresseMapperService} from './inlandsadresse-mapper.service';
import {PersonMapperService} from './person-mapper.service';
import {AuslandsadresseMapperService} from './auslandsadresse-mapper.service';
import {KommunikationsmittelMapperService} from './kommunikationsmittel-mapper.service';
import {AbstractMapper} from '../../abstract.mapper';
import {JuristischePersonMapperService} from './juristische-person-mapper.service';
import {PostfachadresseMapperService} from './postfachadresse-mapper.service';

@Injectable()
export class EmpfangsbevollmaechtigterMapperService
  extends AbstractMapper<StammdatenEmpfangsbevollmaechtigter, MappedStammdatenEmpfangsbevollmaechtigter> {

  constructor(private readonly personMapper: PersonMapperService,
              private readonly juristischePersonMapper: JuristischePersonMapperService,
              private readonly inlandsadresseMapper: InlandsadresseMapperService,
              private readonly auslandsadresseMapper: AuslandsadresseMapperService,
              private readonly postfachadresseMapper: PostfachadresseMapperService,
              private readonly kommunikationsmittelMapper: KommunikationsmittelMapperService) {
    super();
  }

  private static mapPersonenTyp(empfangsbevollmaechtigter: StammdatenEmpfangsbevollmaechtigter): PersonenTypEnum {
    if (empfangsbevollmaechtigter.natuerlichePerson) {
      return PersonenTypEnumLabels.NatPers;
    }
    if (empfangsbevollmaechtigter.juristischePerson) {
      return PersonenTypEnumLabels.NNatPers;
    }
    return undefined;
  }

  protected mapInternal(source: StammdatenEmpfangsbevollmaechtigter): MappedStammdatenEmpfangsbevollmaechtigter {
    return {
      steuerberaterVollmacht: source.steuerberaterVollmacht,
      personenTyp: EmpfangsbevollmaechtigterMapperService.mapPersonenTyp(source),
      natuerlichePerson: this.personMapper.map(source.natuerlichePerson),
      juristischePerson: this.juristischePersonMapper.map(source.juristischePerson),
      inlandsadressen: this.inlandsadresseMapper.mapArrayWithDefault(source.adressen),
      auslandsadressen: this.auslandsadresseMapper.mapArrayWithDefault(source.adressen),
      postfachadressen: this.postfachadresseMapper.mapArrayWithDefault(source.adressen),
      kommunikation: this.kommunikationsmittelMapper.map(source.kommunikation)
    };
  }
}
